import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { ToastContainer, notify } from '../../libraries/notifications';

import { getOwner } from '../../libraries/utils';

import config from '../../config';
import Icon from '../../libraries/icons';
import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar';
import NotifyElement from '../../components/customs/NotifyElement';

import MessagesActions from '../../context/messages/actions';

class Notifications extends React.Component {

  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      messages: [],
    }
  }
  
  componentDidMount() {
    this.getUserMessages();
  }


  getUserMessages = async () => {
    await this.props.onGetAllMessages({ type: config.MESSAGES.TYPE.NOTIFICATION, target: this.props.auth.user.id })
    const { messages } = this.props;
    if (messages.error) {
      notify(messages.error.message);
    } else {
      this.setState({ messages: messages.items });
    }
  }

  

  render() {
    const { messages } = this.state;

    return (
      <LayoutWithSidebar
        main={{ className: "bg-base-200"}}
        header={{ 
          className: "bg-primary text-primary-content",
          title: this.t("Notifications"),
        }}
      >
        <ToastContainer/>
        <div className="h-10 bg-primary"></div>
        <section className="section-card">

          {!this.props.messages.loading && messages.length === 0 && (
            <div className="text-center p-10">
              <Icon className="h-24 w-24 mx-auto mb-3" name="bell" />
              <h4 className="mb-1">{this.t("No tienes notificaciones")}</h4>
            </div>
          )}
          <div className="card white">
            { messages && messages.map((message, index) => 
              <NotifyElement
                key={index}
                data={message}
                className="border-b"
              />
            )}
          </div>
        </section>
      </LayoutWithSidebar>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    messages: state.messages.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllMessages: (params) => dispatch(MessagesActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Notifications));
   

  
